var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9993 2.70801C13.1489 2.70801 13.2702 2.82926 13.2702 2.97884C13.2702 3.12842 13.1489 3.24967 12.9993 3.24967C12.8498 3.24967 12.7285 3.12842 12.7285 2.97884C12.7285 2.82926 12.8498 2.70801 12.9993 2.70801",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7077 4.875H21.1243C21.7227 4.875 22.2077 5.36002 22.2077 5.95833V24.375C22.2077 24.9733 21.7227 25.4583 21.1243 25.4583H4.87435C4.27604 25.4583 3.79102 24.9733 3.79102 24.375V5.95833C3.79102 5.36002 4.27604 4.875 4.87435 4.875H10.291",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7077 6.49984C15.7077 6.79899 15.4652 7.0415 15.166 7.0415H10.8327C10.5335 7.0415 10.291 6.79899 10.291 6.49984V3.24984C10.291 1.75407 11.5036 0.541504 12.9993 0.541504C14.4951 0.541504 15.7077 1.75407 15.7077 3.24984V6.49984Z",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47851 21.5H17.522M8.47852 10.1738H17.522",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1667 16.3333C14.3633 16.3333 15.3333 15.3633 15.3333 14.1667C15.3333 12.97 14.3633 12 13.1667 12C11.97 12 11 12.97 11 14.1667C11 15.3633 11.97 16.3333 13.1667 16.3333Z",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20.9111C16.319 19.0618 14.9183 17.6611 13.25 17.6611C11.5817 17.6611 10.181 19.0618 10 20.9111",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDid);
export default __webpack_public_path__ + "static/media/did.6e4db210ee8823c948418c6997188e42.svg";
export { ForwardRef as ReactComponent };